import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '../domains/auth/authStore';
import { Spinner } from '../design-system/atoms/Spinner';
import { LegalConsentGate } from '../shared/LegalConsentGate';
import { DeletionPendingGate } from '../shared/DeletionPendingGate';

export function AuthBoundary() {
  const location = useLocation();
  const initialized = useAuthStore((state) => state.initialized);
  const loading = useAuthStore((state) => state.loading);
  const user = useAuthStore((state) => state.user);
  const recoveryActive = useAuthStore((state) => state.recoveryActive);
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    if (!initialized) {
      void initialize();
    }
  }, [initialize, initialized]);

  if (!initialized || loading) {
    return <Spinner label="Проверяем сессию..." />;
  }

  // 1.30.0 / P0-4 — Если у юзера активна recovery-сессия (пришёл по
  // ссылке «сбросить пароль»), не пускаем в защищённые области, пока
  // он не сменит пароль на /reset-password. См. authStore.bindAuthListener.
  if (recoveryActive) {
    return <Navigate to="/reset-password" replace />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // 1.34.0 / Б6 — перед допуском к защищённым маршрутам проверяем, что
  // пользователь принял текущие версии всех юридических документов.
  //
  // 1.34.0 / Б9 — затем проверяем, нет ли активного запроса на удаление
  // аккаунта. Если есть — показываем экран с возможностью отмены/выхода.
  // Порядок гейтов важен: сначала юр.условия, потом операционные.
  return (
    <LegalConsentGate>
      <DeletionPendingGate>
        <Outlet />
      </DeletionPendingGate>
    </LegalConsentGate>
  );
}
